import { useCallback } from 'react';

import { type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type DragWorkspaceData } from './useTrackStartedDragging';

export type BaseDragData = {
  numberOfBoards?: number;
  boardIds?: string[];
  numberOfAssets?: number;
  clipIds?: Clip['id'][];
};

export type DropWorkspaceData = DragWorkspaceData & {
  newIndex: number;
};

export type CompletedDraggingParams = (BaseDragData | DropWorkspaceData) & {
  dropLocation: {
    type:
      | 'board'
      | 'asset'
      | 'file'
      | 'rearrange'
      | 'sub-nav-rearrange'
      | 'workspace-rearrange'
      | 'version-rearrange'
      | 'library';
    id?: string;
  };
  usedSelecting?: boolean; // so we know if a used the selection before dragging
};

export const useTrackCompletedDragging = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedDragging = useCallback(
    (params: CompletedDraggingParams) => {
      track(`Completed dragging items`, params);
    },
    [track],
  );

  return { trackCompletedDragging };
};
